export {};
//# sourceMappingURL=screenshotSize.js.map